import Vue from "vue";
import $ from "jquery";
import { Location } from "vue-router/types/router";

export const NavigateToEmitStr = "NavigateTo";

export class EventBusImplementation extends Vue {
	public NavigateTo(route: Location): void {
		this.$emit(NavigateToEmitStr, route);
	}
}

export const EventBus = new EventBusImplementation();

export enum IconeMessage {
	Success = "fa-check",
	Failed = "fa-times;",
	Information = "fa-info-circle",
	Avertissement = "fa-exclamation-triangle"
}

export class NotificationPush {
	public promptSuccessMessage(message: string): void {
		$.notify({
			message: message
		}, {
			type: "success",
			z_index: 99999,
			delay: 1000,
			timer: 3000,
			allow_dismiss: true,
			template: this.getTemplate(IconeMessage.Success)
		});
	}

	public promptFailledMessage(message: string): void {
		$.notify({
			// options
			message: message
		}, {
			// settings
			type: "danger",
			z_index: 99999,
			delay: 1000,
			timer: 3000,
			allow_dismiss: true,
			template: this.getTemplate(IconeMessage.Failed)
		});
	}

	public promptFailledList(messages: string[]): void {
		let messageFinal = "<ul class=\"ml-2\" style=\"list-style-type: disc;\">";

		for (const message of messages) {
			messageFinal += "<li>" + message + "</li>";
		}

		messageFinal += "</ul>";

		$.notify({
			// options
			message: messageFinal
		}, {
			// settings
			type: "danger",
			z_index: 99999,
			delay: 1000,
			timer: 3000,
			allow_dismiss: true,
			template: this.getTemplate(IconeMessage.Failed)
		});
	}

	public promptInformationMessage(message: string): void {
		$.notify({
			// options
			message: message
		}, {
			// settings
			type: "info",
			z_index: 99999,
			delay: 1000,
			timer: 3000,
			allow_dismiss: true,
			template: this.getTemplate(IconeMessage.Information)
		});
	}

	public promptAvertissementMessage(message: string): void {
		$.notify({
			// options
			message: message
		}, {
			// settings
			type: "warning",
			z_index: 99999,
			delay: 1000,
			timer: 3000,
			allow_dismiss: true,
			template: this.getTemplate(IconeMessage.Avertissement)
		});
	}

	public getTemplate(iconeMessage: IconeMessage): string {
		return "<div style=\"user-select: none;\" data-notify=\"container\" class=\"notify col-xs-11 col-sm-3 alert alert-{0}\" role=\"alert\">" +
         "<button type=\"button\" style=\"font-size: 15px;\" aria-hidden=\"true\" class=\"close\" data-notify=\"dismiss\"><span class=\"fas fa-times\"></span></button>" +
         "<span class=\"fas " + iconeMessage + " mr-2\"></span>" +
         "<span data-notify=\"message\" style=\"position:relative;top:-1px;\" class=\"h6 m-0\"><small>{2}</small></span>" +
         "</div>";
	}
}



// WEBPACK FOOTER //
// ./src/components/Controls/EventBus.ts